import React from 'react';
import { Answer, FAQItemWrapper, Question } from './FAQItem.styles';

export type FAQItemProps = {
  /* Will always be wrapped in a <p> tag. If passing a JSX.Element, use <Fragment> to wrap the content. */
  question: string | JSX.Element;
  /* Will always be wrapped in a <p> tag. If passing a JSX.Element, use <Fragment> to wrap the content. */
  answer: string | JSX.Element;
};

const FAQItem: React.FC<FAQItemProps> = (props: FAQItemProps) => {
  const { question, answer } = props;

  return (
    <FAQItemWrapper>
      <Question>{question}</Question>
      <Answer>{answer}</Answer>
    </FAQItemWrapper>
  );
};

export default FAQItem;
